module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/04-01.ff4b00a5.mp3";